import React from 'react';
import {
  Form, Input, Switch, Select,
} from 'antd';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import * as alertsNames from '@pages/Alertas/helpers/defaultAlerts/alertsNames';
import styles from './GeneralAlarma.module.less';

import LayoutStep from '../../components/LayoutStep';
import SpecialCard from '../../components/SpecialCard';

const { Item } = Form;
const { TextArea } = Input;
const { Option } = Select;

function GeneralAlarma(props) {

  const { onNext } = props;
  const { t } = useTranslation();

  const isEditDefault = useSelector(({ inverters }) => inverters.isEditDefault);

  return (
    <LayoutStep onNext={onNext}>
      <SpecialCard>
        <Item
          className={styles.short_input}
          label={t('views.dynamic_alarms_create_edit.labels.name')}
          name="name"
          rules={[
            {
              required: true,
              message: t('views.dynamic_alarms_create_edit.feedbacks.required_input'),
            },
            () => ({
              validator(_, val) {

                const alertsDefaults = Object.values(alertsNames);
                if (!isEditDefault && alertsDefaults.includes(val)) {

                  return Promise.reject(
                    t('views.dynamic_alarms_create_edit.feedbacks.reserved_name'),
                  );

                }
                return Promise.resolve();

              },
            }),
          ]}
        >
          <Input disabled={isEditDefault} />
        </Item>

        {/* <Item
          className={styles.large_input}
          label={t('views.dynamic_alarms_create_edit.labels.active/deactive')}
          name="is_active"
          valuePropName="checked"
        >
          <Switch
            disabled={isEditDefault}
          />
        </Item> */}
      </SpecialCard>
    </LayoutStep>
  );

}

GeneralAlarma.propTypes = {
  onNext: PropTypes.func.isRequired,
};

export default GeneralAlarma;
